/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
/* eslint-disable operator-linebreak */

import { useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addToCart } from '@/store/slices/cart';
import { setAlert } from '@/store/slices/alert';
import { useFetchItems } from '../../services/hooks';

const BarcodeReader = ({ children }) => {
  const dispatch = useDispatch();
  const { data } = useFetchItems('All Item Groups');
  const barcodeRef = useRef('');

  const items = data;

  const findItem = (barcode) => {
    const existingItem = items?.find((item) => item.serial_no === barcode);

    if (existingItem) {
      const itemToBeAdded = {
        item_code: existingItem.item_code,
        item_name: existingItem.item_name,
        description: existingItem.description,
        stock_uom: existingItem.stock_uom,
        qty: 1,
        currency: existingItem.currency,
        price_list_rate: existingItem.price_list_rate,
      };

      dispatch(addToCart(itemToBeAdded));
    } else {
      dispatch(
        setAlert({
          type: 'error',
          message: 'Item not found',
        }),
      );
    }
  };

  const handleBarcode = (event) => {
    const code = event.keyCode ? event.keyCode : event.which;
    barcodeRef.current += String.fromCharCode(code);
    if (code === 13) {
      const barcodeData = barcodeRef.current.replace(/\r$/, '');

      findItem(barcodeData);
      barcodeRef.current = '';
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleBarcode);
    return () => {
      document.removeEventListener('keydown', handleBarcode);
    };
  }, [data]);
  return <>{children}</>;
};

export default BarcodeReader;
